<template>
  <v-form>
    <v-card flat>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <v-menu offset-y auto>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="secondary" v-bind="attrs" class="mr-4" v-on="on">
                  {{ selectedMonth }}
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="(item, index) in range(1, 12)"
                  :key="index"
                  @click="selectedMonth = item"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <v-menu offset-y auto>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="secondary" v-bind="attrs" class="mr-4" v-on="on">
                  {{ selectedYear }}
                </v-btn>
              </template>
              <v-list dense>
                <v-list-item
                  v-for="(item, index) in range(2017, new Date().getFullYear())"
                  :key="index"
                  @click="selectedYear = item"
                >
                  <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
          <v-col col="12" sm="6">
            <v-select
              :items="fleets"
              item-text="Name"
              return-object
              :label="$vuetify.lang.t('$vuetify.EDIT_FLEETS.SELECT_FLEET')"
              :loading="loading.state && loading.type === 'getFleets'"
              :value="selectedFleet"
              outlined
              hide-details
              @change="selectedFleet = $event"
            ></v-select>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-btn
              :disabled="!selectedFleet"
              :loading="
                loading.state && loading.type === 'fleets.getAvailabilityInfo'
              "
              color="white"
              class="success--text mr-3"
              :class="$vuetify.breakpoint.smAndDown ? 'mb-3' : ''"
              @click="generateFleetReport()"
            >
              {{ $vuetify.lang.t('$vuetify.GENERATE') }}
            </v-btn>
            <v-btn
              :disabled="!selectedFleet"
              :loading="loading.state && loading.type === 'getFleetXLSX'"
              color="white"
              class="success--text"
              :class="$vuetify.breakpoint.smAndDown ? 'mb-3' : ''"
              @click="getFleetReport()"
            >
              <v-icon class="mr-2">mdi-microsoft-excel</v-icon>
              {{ $vuetify.lang.t('$vuetify.EXPORT_TO_EXCEL') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-data-iterator
          v-if="totalInfo"
          content-tag="tag"
          row
          wrap
          :items="[totalInfo]"
          rows-per-page="1"
          hide-default-footer=""
        >
          <template v-slot:default="props">
            <v-row>
              <v-col
                v-for="item in props.items"
                :key="item.name"
                cols="12"
                sm="6"
                md="4"
                lg="3"
              >
                <v-card>
                  <v-list dense>
                    <v-list-item>
                      <v-list-item-content>
                        {{
                          $vuetify.lang.t(
                            '$vuetify.EDIT_WHITELISTS.SESSIONS_COUNT'
                          )
                        }}
                      </v-list-item-content>
                      <v-list-item-content class="align-end">{{
                        item.SessionsCount
                      }}</v-list-item-content>
                    </v-list-item>

                    <!-- <v-list-item>
                      <v-list-item-content
                        >Pargitud minuteid:</v-list-item-content
                      >
                      <v-list-item-content class="align-end">{{
                        item.ParkingMinutes
                      }}</v-list-item-content>
                    </v-list-item> -->

                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-content>
                          {{ $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.COST') }}
                        </v-list-item-content>
                      </v-list-item-content>
                      <v-list-item-content class="align-end">
                        {{ item.TotalCostInCents / 100 }}
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>
        <!-- <v-expansion-panels>
          <v-expansion-panel v-for="user in reportRows" :key="user.FleetUserId">
            <v-expansion-panel-header>
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">Phone number</th>
                      <th class="text-left">Licence plate</th>
                      <th class="text-left">Name</th>
                      <th class="text-left">Email</th>
                      <th class="text-left">Daily limit</th>
                      <th class="text-left">Monthly limit</th>
                      <th class="text-left">Used credit</th>
                      <th class="text-left">Available credit</th>
                      <th class="text-left">Over limit</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{{ user.PhoneNumber }}</td>
                      <td>{{ user.CarNumber }}</td>
                      <td>{{ user.Name }}</td>
                      <td>{{ user.Email }}</td>
                      <td>{{ user.DailyLimitInCents / 100.0 }}</td>
                      <td>{{ user.MonthlyLimitInCents / 100.0 }}</td>
                      <td>
                        <span
                          :class="{
                            'red--text':
                              user.UsedFleetCreditCents ==
                              user.MonthlyLimitInCents
                          }"
                        >
                          {{ user.UsedFleetCreditCents / 100.0 }}
                          {{ user.Currency }}
                        </span>
                      </td>
                      <td>
                        <span
                          :class="{
                            'red--text':
                              user.UsedFleetCreditCents ==
                              user.MonthlyLimitInCents,
                            'success--text':
                              user.UsedFleetCreditCents <
                              user.MonthlyLimitInCents
                          }"
                        >
                          {{
                            (user.MonthlyLimitInCents -
                              user.UsedFleetCreditCents) /
                              100.0
                          }}
                          {{ user.Currency }}
                        </span>
                      </td>
                      <td>
                        <span
                          v-show="user.SelfPaidCents > 0"
                          class="warning--text"
                        >
                          {{ user.SelfPaidCents / 100.0 }} {{ user.Currency }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              Content
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels> -->
        <!-- <v-simple-table v-if="reportRows && reportRows.length">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Phone number</th>
                <th class="text-left">Licence plate</th>
                <th class="text-left">Name</th>
                <th class="text-left">Email</th>
                <th class="text-left">Daily limit</th>
                <th class="text-left">Monthly limit</th>
                <th class="text-left">Used credit</th>
                <th class="text-left">Available credit</th>
                <th class="text-left">Over limit</th>
                <th class="text-right"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="user in reportRows" :key="user.FleetUserId">
                <td>{{ user.PhoneNumber }}</td>
                <td>{{ user.CarNumber }}</td>
                <td>{{ user.Name }}</td>
                <td>{{ user.Email }}</td>
                <td>{{ user.DailyLimitInCents / 100.0 }}</td>
                <td>{{ user.MonthlyLimitInCents / 100.0 }}</td>
                <td>
                  <span
                    :class="{
                      'red--text':
                        user.UsedFleetCreditCents == user.MonthlyLimitInCents
                    }"
                  >
                    {{ user.UsedFleetCreditCents / 100.0 }}
                    {{ user.Currency }}
                  </span>
                </td>
                <td>
                  <span
                    :class="{
                      'red--text':
                        user.UsedFleetCreditCents == user.MonthlyLimitInCents,
                      'success--text':
                        user.UsedFleetCreditCents < user.MonthlyLimitInCents
                    }"
                  >
                    {{
                      (user.MonthlyLimitInCents - user.UsedFleetCreditCents) /
                        100.0
                    }}
                    {{ user.Currency }}
                  </span>
                </td>
                <td>
                  <span v-show="user.SelfPaidCents > 0" class="warning--text">
                    {{ user.SelfPaidCents / 100.0 }} {{ user.Currency }}
                  </span>
                </td>
                <td>
                  <v-btn icon>
                    <v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table> -->

        <v-row v-if="sessionRows.length">
          <v-col cols="12">
            <v-data-table
              :headers="[
                {
                  text: 'Session ID',
                  align: 'start',
                  sortable: false,
                  value: 'ParkingSessionId'
                },
                {
                  text: this.$vuetify.lang.t('$vuetify.LOCATION'),
                  value: 'PlaceAddress'
                },
                {
                  text: this.$vuetify.lang.t('$vuetify.NAME'),
                  value: 'ClientName'
                },
                {
                  text: this.$vuetify.lang.t('$vuetify.PHONE_NUMBER'),
                  value: 'ClientPhoneNumber'
                },
                {
                  text: this.$vuetify.lang.t('$vuetify.CAR_NUMBER'),
                  value: 'CarNumber'
                },
                {
                  text: this.$vuetify.lang.t('$vuetify.START_TIME'),
                  value: 'StartTime'
                },
                {
                  text: this.$vuetify.lang.t('$vuetify.END_TIME'),
                  value: 'EndTime'
                },
                {
                  text: this.$vuetify.lang.t('$vuetify.EDIT_WHITELISTS.COST'),
                  value: 'TotalCostInCents'
                }
              ]"
              :items="sessionRows"
              class="elevation-1"
              hide-default-footer
              :items-per-page="sessionRows.length"
            >
              <template v-slot:item.StartTime="props">
                <td>{{ dateEE(props.item.StartTime) }}</td>
              </template>
              <template v-slot:item.EndTime="props">
                <td>{{ dateEE(props.item.EndTime) }}</td>
              </template>
              <template v-slot:item.TotalCostInCents="props">
                <td>
                  {{ props.item.TotalCostInCents / 100 }}
                  {{ props.item.Currency }}
                </td>
              </template>
            </v-data-table>
          </v-col>
        </v-row>

        <v-data-table
          v-if="reportRows && reportRows.length > 1"
          :headers="computedHeaders"
          :items="reportRows"
          single-expand
          :expanded.sync="expanded"
          item-key="FleetUserId"
          show-expand
          :items-per-page="-1"
          hide-default-footer
          class="elevation-1"
        >
          <template v-slot:item.DailyLimitInCents="props">
            <td>
              {{ props.item.DailyLimitInCents / 100 }}
              {{ reportCurrency }}
            </td>
          </template>
          <template v-slot:item.MonthlyLimitInCents="props">
            <td>
              {{ props.item.MonthlyLimitInCents / 100 }}
              {{ reportCurrency }}
            </td>
          </template>
          <template v-slot:item.SelfPaidCents="props">
            <td>
              {{ props.item.SelfPaidCents / 100 }}
              {{ reportCurrency }}
            </td>
          </template>
          <template v-slot:item.AvailableCredit="props">
            <td>
              {{
                (props.item.MonthlyLimitInCents -
                  props.item.UsedFleetCreditCents) /
                  100
              }}
              {{ reportCurrency }}
            </td>
          </template>
          <template v-slot:item.UsedFleetCreditCents="props">
            <td>{{ props.item.UsedFleetCreditCents / 100 }}</td>
          </template>
          <template
            v-slot:item.data-table-expand="{ item, isExpanded, expand }"
          >
            <v-btn
              v-if="item.ParkingSessions.length && !isExpanded"
              icon
              @click="expand(true)"
            >
              <v-icon>mdi-menu-down</v-icon>
            </v-btn>
            <v-btn
              v-if="item.ParkingSessions.length && isExpanded"
              icon
              @click="expand(false)"
            >
              <v-icon>mdi-menu-up</v-icon>
            </v-btn>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td
              v-if="item.ParkingSessions.length"
              :colspan="headers.length"
              class="pa-0 session-row"
            >
              <v-data-table
                :headers="[
                  {
                    text: 'Session ID',
                    align: 'start',
                    sortable: false,
                    value: 'ParkingSessionId'
                  },
                  {
                    text: $vuetify.lang.t('$vuetify.LOCATION'),
                    value: 'PlaceAddress'
                  },
                  {
                    text: $vuetify.lang.t('$vuetify.CAR_NUMBER'),
                    value: 'CarNumber'
                  },
                  {
                    text: $vuetify.lang.t('$vuetify.START_TIME'),
                    value: 'StartTime'
                  },
                  {
                    text: $vuetify.lang.t('$vuetify.END_TIME'),
                    value: 'EndTime'
                  },
                  {
                    text: $vuetify.lang.t('$vuetify.EDIT_WHITELISTS.COST'),
                    value: 'TotalCostInCents'
                  }
                ]"
                :items="item.ParkingSessions"
                class="elevation-0 rounded-0 grey lighten-3"
                hide-default-footer
                :items-per-page="-1"
              >
                <template v-slot:item.StartTime="props">
                  <td>{{ dateEE(props.item.StartTime) }}</td>
                </template>
                <template v-slot:item.EndTime="props">
                  <td>{{ dateEE(props.item.EndTime) }}</td>
                </template>
                <template v-slot:item.TotalCostInCents="props">
                  <td>
                    {{ props.item.TotalCostInCents / 100 }}
                    {{ props.item.Currency }}
                  </td>
                </template>
              </v-data-table>
            </td>
          </template>
        </v-data-table>

        <!-- <v-row v-if="reportRows && reportRows.length">
          <v-col cols="12">
            <v-data-table
              :headers="[
                {
                  text: 'Session ID',
                  align: 'start',
                  sortable: false,
                  value: 'ParkingSessionId'
                },
                {
                  text: this.$vuetify.lang.t('$vuetify.LOCATION'),
                  value: 'PlaceAddress'
                },
                {
                  text: this.$vuetify.lang.t('$vuetify.NAME'),
                  value: 'ClientName'
                },
                {
                  text: this.$vuetify.lang.t('$vuetify.PHONE_NUMBER'),
                  value: 'ClientPhoneNumber'
                },
                {
                  text: this.$vuetify.lang.t('$vuetify.CAR_NUMBER'),
                  value: 'CarNumber'
                },
                {
                  text: this.$vuetify.lang.t('$vuetify.START_TIME'),
                  value: 'StartTime'
                },
                {
                  text: this.$vuetify.lang.t('$vuetify.END_TIME'),
                  value: 'EndTime'
                },
                {
                  text: this.$vuetify.lang.t('$vuetify.EDIT_WHITELISTS.COST'),
                  value: 'TotalCostInCents'
                }
              ]"
              :items="reportRows"
              class="elevation-1"
              hide-default-footer
              :items-per-page="reportRows.length"
            >
              <template v-slot:item.StartTime="props">
                <td>{{ dateEE(props.item.StartTime) }}</td>
              </template>
              <template v-slot:item.EndTime="props">
                <td>{{ dateEE(props.item.EndTime) }}</td>
              </template>
              <template v-slot:item.TotalCostInCents="props">
                <td>
                  {{ props.item.TotalCostInCents / 100 }}
                  {{ props.item.Currency }}
                </td>
              </template>
            </v-data-table>
          </v-col>
        </v-row> -->
      </v-card-text>
    </v-card>
  </v-form>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import formatDate from '@/mixins/formatDate'

export default {
  name: 'FleetReport',
  mixins: [formatDate],
  computed: {
    ...mapGetters('app', ['loading']),
    ...mapGetters('fleets', ['fleets', 'fleet']),
    computedHeaders() {
      const headers = [
        {
          hideIfFleetHasManagers: true,
          text: this.$vuetify.lang.t('$vuetify.PHONE_NUMBER'),
          align: 'start',
          sortable: false,
          value: 'PhoneNumber'
        },
        {
          hideIfFleetHasManagers: true,
          text: this.$vuetify.lang.t('$vuetify.CAR_NUMBER'),
          value: 'CarNumber'
        },
        {
          hideIfFleetHasManagers: false,
          text: this.$vuetify.lang.t('$vuetify.NAME'),
          value: 'Name'
        },
        { hideIfFleetHasManagers: true, text: 'Email', value: 'Email' },
        {
          hideIfFleetHasManagers: true,
          text: this.$vuetify.lang.t('$vuetify.FLEET_REPORT.DAILY_LIMIT'),
          value: 'DailyLimitInCents'
        },
        {
          hideIfFleetHasManagers: true,
          text: this.$vuetify.lang.t('$vuetify.FLEET_REPORT.MONTHLY_LIMIT'),
          value: 'MonthlyLimitInCents'
        },
        {
          hideIfFleetHasManagers: false,
          text: this.$vuetify.lang.t('$vuetify.FLEET_REPORT.USED_FLEET_CREDIT'),
          value: 'UsedFleetCreditCents'
        },
        {
          hideIfFleetHasManagers: true,
          text: this.$vuetify.lang.t(
            '$vuetify.FLEET_REPORT.AVAILABLE_FLEET_CREDIT'
          ),
          value: 'AvailableCredit'
        },
        {
          hideIfFleetHasManagers: true,
          text: this.$vuetify.lang.t('$vuetify.FLEET_REPORT.OVER_LIMIT'),
          value: 'SelfPaidCents'
        },

        { text: '', sortable: false, value: 'data-table-expand' }
      ]
      return headers.filter(col => {
        if (col.hideIfFleetHasManagers) {
          if (this.selectedFleetHasManagers) {
            return false
          }
          return col
        }
        return col
      })
    }
  },
  data() {
    return {
      selectedFleet: '',
      selectedMonth: new Date().getMonth() + 1,
      selectedYear: new Date().getFullYear(),
      reportRows: [],
      sessionRows: [],
      totalInfo: null,
      expanded: [],
      selectedFleetHasManagers: false,
      reportCurrency: ''
    }
  },
  watch: {
    fleets() {
      // Eslint rule does not match this use case very well.
      // eslint-disable-next-line prefer-destructuring
      this.selectedFleet = this.fleets[0]
    },
    async selectedFleet() {
      this.reportRows = []
      this.totalInfo = null
      await this.getFleet(this.selectedFleet.Id)
      if (
        this.reportRows.length &&
        (this.fleet.Managers.length || this.selectedFleet.Managers.length)
      ) {
        this.selectedFleetHasManagers = true
      } else {
        this.selectedFleetHasManagers = false
      }
    }
  },
  created() {
    const currentDate = new Date()
    this.selectedValidFrom = this.formatDate(
      new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
    )
    this.selectedValidTo = this.formatDate(new Date())
  },
  async mounted() {
    await this.getFleets()
    if (this.fleets && this.fleets.length) {
      // eslint-disable-next-line prefer-destructuring
      this.selectedFleet = this.fleets[0]
      await this.getFleet(this.selectedFleet.Id)
      if (this.fleet.Managers.length || this.selectedFleet.Managers.length) {
        this.selectedFleetHasManagers = true
      } else {
        this.selectedFleetHasManagers = false
      }
    }
  },
  methods: {
    ...mapActions('fleets', ['getFleets', 'getFleet', 'getFleetXLSX']),
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
    },
    // Returns array of numbers, eg. with input(1,12) [1,2,3,.....,12]
    range(from, to) {
      const list = []
      for (let i = from; i <= to; i += 1) {
        list.push(i)
      }
      return list
    },
    async generateFleetReport() {
      this.reportRows = []
      let sessionsCount = 0
      let costTotal = 0
      await this.$store
        .dispatch('fleets/getAvailabilityInfo', {
          fleetId: this.selectedFleet.Id,
          month: this.selectedMonth,
          year: this.selectedYear
        })
        .then(response => {
          if (response.data.ReportRows.length === 1) {
            response.data.ReportRows.forEach(row => {
              row.ParkingSessions.forEach(sess => {
                sessionsCount += 1
                costTotal += sess.TotalCostInCents
                this.sessionRows.push(sess)
              })
            })
          } else {
            this.sessionRows = []
            this.reportRows = response.data.ReportRows
            this.reportRows.forEach(row => {
              row.ParkingSessions.forEach(sess => {
                sessionsCount += 1
                costTotal += sess.TotalCostInCents
              })
            })
          }
          this.reportCurrency = response.data.Currency
        })

      this.totalInfo = {
        SessionsCount: sessionsCount,
        TotalCostInCents: costTotal
      }
    },
    getFleetReport() {
      this.getFleetXLSX({
        id: this.selectedFleet.Id,
        month: this.selectedMonth,
        year: this.selectedYear
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute(
          'download',
          `${this.selectedFleet.Name.replace(/\s/g, '-')}-${
            this.selectedMonth
          }-${this.selectedYear}.xlsx`
        )
        document.body.appendChild(link)
        link.click()
      })
    }
  }
}
</script>
<style scoped>
.session-row
  .v-data-table
  /deep/
  tbody
  /deep/
  tr:hover:not(.v-data-table__expanded__content) {
  background: grey !important;
  color: white !important;
  transition: 0.3s;
}
</style>
